import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import * as _ from "lodash";
import { isEqual, pick } from "lodash";
import { Observable, of } from "rxjs";
import { CameraComponent } from "src/app/annotation/camera/camera.component";
import { PictureData } from "src/app/annotation/canvas/canvas.component";
import { PictureInfo } from "src/app/core/survey/shared/components/photo-and-remark/photo-viewmodel";
import { FormValidationService } from "src/app/core/survey/shared/services/formValidation.service";
import { SavingStateService } from "src/app/core/survey/shared/services/saving-state.service";
import { InsideCopperIntroPhotoRemarksDto } from "src/app/shared/Models/write/InsideCopperIntroPhotoRemarksDto";
import { InsideFibreIntroPhotoRemarksDto } from "src/app/shared/Models/write/InsideFibreIntroPhotoRemarksDto";
import { OutsideCopperIntroPhotoRemarksDto } from "src/app/shared/Models/write/OutsideCopperIntroPhotoRemarksDto";
import { OutsideFibreIntroPhotoRemarksDto } from "src/app/shared/Models/write/OutsideFibreIntroPhotoRemarksDto";
import { ProximusEquipmentPhotoRemarksDto } from "src/app/shared/Models/write/ProximusEquipmentPhotoRemarksDto.1";
import { SurveyPhotoTypeEnum } from "../../../../../../shared/Models/enums/SurveyPhotoTypeEnum";
import { InsideSurvey } from "../../../../../../shared/Models/read";
import { UpdateInsideSurveyTechnicalInfoDTO } from "../../../../../../shared/Models/write/updateInsideSurveyTechnicalInfoDTO";
import { InsideSurveyService } from "../../../../../../shared/services/inside-survey.service";
import { ToastService } from "../../../../../../shared/toast.service";
import {
  InsideSurveyInsideInfo,
  INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
} from "../../../config/inside-survey.magic-strings";
import { InsideSurveyTab } from "../../../models/insideSurveyTab.interface";
import { Quadrant } from "../../../models/quadrant.enum";
import { ValidationError } from "../../../../../../shared/Models/ValidationError";

const photoRemarks = {
  generalTechnicalInfoPhotoRemark: "generalTechnicalInfoPhotoRemark",
  electricityInTelcoRoomPhotoRemark: "electricityInTelcoRoomPhotoRemark",
  roomAvailableForNewEquipmentPhotoRemark:
    "roomAvailableForNewEquipmentPhotoRemark",
  proximusEquipmentPhotoRemark: "proximusEquipmentPhotoRemark",
  telcoRoomIntroPhotoRemark: "telcoRoomIntroPhotoRemark",
  insideCopperIntroPhotoRemark: "insideCopperIntroPhotoRemark",
  outsideCopperIntroPhotoRemark: "outsideCopperIntroPhotoRemark",
  insideFibreIntroPhotoRemark: "insideFibreIntroPhotoRemark",
  outsideFibreIntroPhotoRemark: "outsideFibreIntroPhotoRemark",
};

const generalInfoTechnicalFields = [
  "introduction",
  "quadrant",
  "horizontalTechnicalShaft",
  "verticalTechnicalShaft",
  "electricityInTelcoRoom",
  "roomAvailableForFutureIntroBox",
  "otherTelcoRemarks",
  "generalTechnicalInfoPhotoRemark",
  "electricityInTelcoRoomPhotoRemark",
  "roomAvailableForNewEquipmentPhotoRemark",
];

export const additionalQuestionFields = {
  nrOfGutters: "nrOfGutters",
  nrOf90DegreeCorners: "nrOf90DegreeCorners",
  nrOfInsideOutsideCorners: "nrOfInsideOutsideCorners",
  nrOfEndKitsForGutters: "nrOfEndKitsForGutters",
  nrOfHorizontalDrilling: "nrOfHorizontalDrilling",
  nrOfVerticalDrilling: "nrOfVerticalDrilling",
  nrOfSealingKitsForDrillingHoles: "nrOfSealingKitsForDrillingHoles",
  sellingHigherThan3and5m: "sellingHigherThan3and5m",
};

const existingTelcoFields = [
  "individualCoaxCableFromBasement",
  "copperIntroType",
  "existingTelcoCoax",
  "existingTelcoCoaxQuantity",
  "existingTelcoConnections",
  "existingVerticalCabling",
  "nrOfCopperIntros",
  "nrOfDesiredFibreIntros",
];

const accessToTelcoFields = [
  "accessToTelcoGeneralRemarks",
  "proximusEquipmentPhotoRemark",
];

const specialBuildingFields = [
  "specialBuilding",
  "specialBuildingRemark",
  "heightOver3M50",
  "specificHeightSpecialNeeds",
  "specificInstructionsAesthetics",
  "standardCableDuctsObligatory",
  "specialCableDuctOrStandardCableDuctMoreThan20M",
  "needForSpeedpipeTypeSheath",
  "needForFlextubeTypeSheath",
  "passageThroughExteriorHallway",
  "passageOutsideSpecificEquipment",
  "passageThroughFalseCeilings",
  "passageThroughFalseFloor",
  "floorboxNotOnSameFloorAsApartment",
  "serviceLineConnection",
  "severalTechnicalShafts",
  "floorboxPresentInQuadrantC",
  "extensionOfExistingTechnicalShaft",
  "cableMoreThan50MOr2ManFiber",
  "specialDrilling",
  "mivbStibStation",
  "accessToBuilding",
  "shadowportfolioSolution",
];
const noAdminTSAFields = ["tsaType"];

const propertyNames = {
  introduction: "Introduction",
  quadrant: "Quadrant",
  horizontalTechnicalShaft: "Horizontal technical shaft",
  verticalTechnicalShaft: "Vertical technical shaft",
  electricityInTelcoRoom: "Electricity in Telco Room",
  roomAvailableForFutureIntroBox: "Room available for new equipment ",

  nrOfGutters: "Cable protection gutters",
  nrOf90DegreeCorners: "90° corner pieces",
  nrOfInsideOutsideCorners: "Inside/outside corner pieces",
  nrOfEndKitsForGutters: "End kits for cable gutters",
  nrOfHorizontalDrilling: "Horizontal drillings",
  nrOfVerticalDrilling: "Vertical drillings",
  nrOfSealingKitsForDrillingHoles: "Sealing kits for wall/floor drillingholes",
  sellingHigherThan3and5m:
    "Scaffold is required for installation (seilings higher than 3,5m)",

  individualCoaxCableFromBasement: "Individual coax cable from basement",
  copperIntroType: "Copper intro type",
  existingTelcoCoax: "Coax",
  existingTelcoCoaxQuantity: "CoaxQuantity",

  existingTelcoConnections: "Connections",
  existingVerticalCabling: "Existing vertical cabling",

  nrOfCopperIntros: "No. of copper intros",
  nrOfDesiredFibreIntros: "No. of desired fibre intros",
};
const RESULT = "result";

@Component({
  selector: "app-inside-survey-inside-technical-info",
  templateUrl: "./inside-survey-inside-technical-info.component.html",
  styleUrls: ["./inside-survey-inside-technical-info.component.scss"],
})
export class InsideSurveyInsideTechnicalInfoComponent
  implements InsideSurveyTab, OnInit, AfterViewInit
{
  tabId: string = INSIDE_SURVEY_INSIDE_TECHNICAL_INFO;
  @Input() survey: InsideSurvey;
  @Input() isAuthCanWrite: boolean;
  @Input() cameraLayer: HTMLDivElement;
  @Input() camera: CameraComponent;
  technicalInfoForm: FormGroup = new FormGroup({});

  @Input() viewerLayer: HTMLDivElement;

  newPhotoType: SurveyPhotoTypeEnum;
  newPhotoIndex: number;
  proximusEquipmentPhotoComments: ProximusEquipmentPhotoRemarksDto[];
  telcoRoomPhotoRemarks: ProximusEquipmentPhotoRemarksDto[];
  insideCopperIntroPhotoComments: InsideCopperIntroPhotoRemarksDto[];
  outsideCopperIntroPhotoComments: OutsideCopperIntroPhotoRemarksDto[];
  insideFibreIntroPhotoComments: InsideFibreIntroPhotoRemarksDto[];
  outsideFibreIntroPhotoComments: OutsideFibreIntroPhotoRemarksDto[];
  gotPhotoCallback: (data: PictureData) => void;
  generalTechnicalInfoPhotos;
  pictures: {
    generalTechnicalInfoPhotos: PictureInfo[];
    outsideCopperIntroPhotos: PictureInfo[];
    insideCopperIntroPhotos: PictureInfo[];
    outsideFibreIntroPhotos: PictureInfo[];
    insideFibreIntroPhotos: PictureInfo[];
    telcoRoomPhotos: PictureInfo[];
    proximusEquipmentPhotos: PictureInfo[];
    electricityInTelcoRoomPhotos: PictureInfo[];
    roomAvailableForNewEquipmentPhotos: PictureInfo[];
  } = {
    generalTechnicalInfoPhotos: [],
    outsideCopperIntroPhotos: [],
    insideCopperIntroPhotos: [],
    outsideFibreIntroPhotos: [],
    insideFibreIntroPhotos: [],
    telcoRoomPhotos: [],
    proximusEquipmentPhotos: [],
    electricityInTelcoRoomPhotos: [],
    roomAvailableForNewEquipmentPhotos: [],
  };

  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    private insideSurveyService: InsideSurveyService,
    private _savingStateService: SavingStateService,
    private formValidationService: FormValidationService
  ) {}

  get insideSurveyInsideInfo(): typeof InsideSurveyInsideInfo {
    return InsideSurveyInsideInfo;
  }

  ngOnInit() {
    this.formValidationService.addFormError(
      [INSIDE_SURVEY_INSIDE_TECHNICAL_INFO],
      {
        [InsideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE]: {
          [InsideSurveyInsideInfo.QUADRANT_FIELD]: false,
          [InsideSurveyInsideInfo.INTRODUCTION_FIELD]: false,
          [InsideSurveyInsideInfo.NUM_90_DEGREE_CORNERS_FIELD]: false,
          [InsideSurveyInsideInfo.NUM_ENDKITS_GUTTERS_FIELD]: false,
          [InsideSurveyInsideInfo.NUMBER_GUTTERS_FIELD]: false,
          [InsideSurveyInsideInfo.NUM_HORIZONTAL_DRILLING_FIELD]: false,
          [InsideSurveyInsideInfo.NUM_INSIDE_OUTSIDE_CORNERS_FIELD]: false,
          [InsideSurveyInsideInfo.NUM_SEALING_KITS_DRILLING_HOLES_FIELD]: false,
          [InsideSurveyInsideInfo.NUM_VERTICAL_DRILLING_FIELD]: false,
          [InsideSurveyInsideInfo.SELLING_HIGHER_THAN_3_5_FIELD]: false,
        },
        [InsideSurveyInsideInfo.HORIZONTAL_VERTICAL_INFO_SUBTITLE]: {
          [InsideSurveyInsideInfo.VERTICAL_SHAFT_FIELD]: false,
          [InsideSurveyInsideInfo.HORIZONTAL_TECHNICAL_SHAFT_FIELD]: false,
        },
        [InsideSurveyInsideInfo.ELECTRICITY_OTHER_INFO_SUBTITLE]: {
          [InsideSurveyInsideInfo.ROOM_AVAILABLE_FUTURE_INTRO_BOX_FIELD]: false,
        },
        [InsideSurveyInsideInfo.CONNECTIONS_CABLING_INFO_SUBTITLE]: {
          [InsideSurveyInsideInfo.COAX_QUANTITY_FIELD]: false,
        },
        [InsideSurveyInsideInfo.TSA_TECHNICALSOLUTION_NOT_PROVIDED]: {
          [InsideSurveyInsideInfo.TSA_TECHNICALSOLUTION_NOT_PROVIDED]: false,
        },
        [InsideSurveyInsideInfo.COPPER_INTROS_SUBTITLE]: {
          [InsideSurveyInsideInfo.OUTSIDE_COPPER_INTROS_FIELD]: false,
          [InsideSurveyInsideInfo.INSIDE_COPPER_INTROS_FIELD]: false,
        },
        [InsideSurveyInsideInfo.DESIRED_FIBER_SUBTITLE]: {
          [InsideSurveyInsideInfo.OUTSIDE_DESIRED_FIBER_FIELD]: false,
          [InsideSurveyInsideInfo.INSIDE_DESIRED_FIBER_FIELD]: false,
        },
        [InsideSurveyInsideInfo.TELCO_ROOM_SUBTITLE]: {
          [InsideSurveyInsideInfo.TELCO_ROOM_PHOTO_FIELD]: false,
        },
        [InsideSurveyInsideInfo.PROXIMUS_EQUIPMENT_SUBTITLE]: {
          [InsideSurveyInsideInfo.PROXIMUS_EQUIPMENT_PHOTO_FIELD]: false,
        },
        [InsideSurveyInsideInfo.VERTICAL_PHOTO_SUBTITLE]: {
          [InsideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_PHOTOS]: false,
        },
        [InsideSurveyInsideInfo.ELECTRICITY_PHOTO_SUBTITLE]: {
          [InsideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_PHOTOS]: false,
          [InsideSurveyInsideInfo.ELECTRICITY_TELCO_ROOM_PHOTOS_FIELD]: false,
          [InsideSurveyInsideInfo.ROOM_AVAILABLE_NEW_EQUIPMENT_PHOTOS_FIELD]:
            false,
        },
      }
    );
    this.pictures = {
      generalTechnicalInfoPhotos:
        this.survey.photos.generalTechnicalInfoPhotos.map(
          (dto) => new PictureInfo(dto)
        ),
      outsideCopperIntroPhotos: this.survey.photos.outsideCopperIntroPhotos.map(
        (dto) => new PictureInfo(dto)
      ),
      insideCopperIntroPhotos: this.survey.photos.insideCopperIntroPhotos.map(
        (dto) => new PictureInfo(dto)
      ),
      outsideFibreIntroPhotos: this.survey.photos.outsideFibreIntroPhotos,
      insideFibreIntroPhotos: this.survey.photos.insideFibreIntroPhotos,
      telcoRoomPhotos: this.survey.photos.telcoRoomPhotos,
      proximusEquipmentPhotos: this.survey.photos.proximusEquipmentPhotos.map(
        (dto) => new PictureInfo(dto)
      ),
      electricityInTelcoRoomPhotos:
        this.survey.photos.electricityInTelcoRoomPhotos.map(
          (dto) => new PictureInfo(dto)
        ),
      roomAvailableForNewEquipmentPhotos:
        this.survey.photos.roomAvailableForNewEquipmentPhotos.map(
          (dto) => new PictureInfo(dto)
        ),
    };

    this.technicalInfoForm = this.fb.group({
      generalInfo: ["", []],
      existingTelco: ["", []],
      accessToTelco: ["", []],
      specialBuilding: ["", []],
      noAdminTSA: ["", []],
    });

    this.technicalInfoForm.patchValue({
      generalInfo: pick(this.survey, [
        ...generalInfoTechnicalFields,
        ..._.values(additionalQuestionFields),
      ]),
      existingTelco: pick(this.survey, existingTelcoFields),
      accessToTelco: pick(this.survey, accessToTelcoFields),
      specialBuilding: pick(this.survey, specialBuildingFields),
      noAdminTSA: pick(this.survey, noAdminTSAFields),
    });

    if (
      this.survey.generalTechnicalInfoPhotoRemark &&
      this.pictures.generalTechnicalInfoPhotos.length
    )
      this.pictures.generalTechnicalInfoPhotos[0][
        photoRemarks.generalTechnicalInfoPhotoRemark
      ] = this.survey.generalTechnicalInfoPhotoRemark;

    if (
      this.survey.roomAvailableForNewEquipmentPhotoRemark &&
      this.pictures.roomAvailableForNewEquipmentPhotos.length
    )
      this.pictures.roomAvailableForNewEquipmentPhotos[0][
        photoRemarks.roomAvailableForNewEquipmentPhotoRemark
      ] = this.survey.roomAvailableForNewEquipmentPhotoRemark;

    if (
      this.survey.electricityInTelcoRoomPhotoRemark &&
      this.pictures.electricityInTelcoRoomPhotos.length
    )
      this.pictures.electricityInTelcoRoomPhotos[0][
        photoRemarks.electricityInTelcoRoomPhotoRemark
      ] = this.survey.electricityInTelcoRoomPhotoRemark;
  }

  getErrors(fields: string[]): boolean {
    return fields?.some((field) =>
      this.formValidationService.getErrors(
        INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
        field
      )
    );
  }

  ngAfterViewInit(): void {
    this.init();
  }

  private init() {}

  toggleLayer(layer: HTMLDivElement) {
    layer.classList.toggle("hidden");
  }

  private inMinMax(val: number, min: number, max: number) {
    return val && val >= min && val <= max;
  }

  getSubtitleByField(field: string): string {
    switch (field) {
      case InsideSurveyInsideInfo.QUADRANT_FIELD:
      case InsideSurveyInsideInfo.INTRODUCTION_FIELD:
      case InsideSurveyInsideInfo.NUM_90_DEGREE_CORNERS_FIELD:
      case InsideSurveyInsideInfo.NUM_ENDKITS_GUTTERS_FIELD:
      case InsideSurveyInsideInfo.NUMBER_GUTTERS_FIELD:
      case InsideSurveyInsideInfo.NUM_HORIZONTAL_DRILLING_FIELD:
      case InsideSurveyInsideInfo.NUM_INSIDE_OUTSIDE_CORNERS_FIELD:
      case InsideSurveyInsideInfo.NUM_SEALING_KITS_DRILLING_HOLES_FIELD:
      case InsideSurveyInsideInfo.NUM_VERTICAL_DRILLING_FIELD:
      case InsideSurveyInsideInfo.SELLING_HIGHER_THAN_3_5_FIELD:
        return InsideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE;
      case InsideSurveyInsideInfo.HORIZONTAL_TECHNICAL_SHAFT_FIELD:
      case InsideSurveyInsideInfo.VERTICAL_SHAFT_FIELD:
        return InsideSurveyInsideInfo.HORIZONTAL_VERTICAL_INFO_SUBTITLE;
      case InsideSurveyInsideInfo.ROOM_AVAILABLE_FUTURE_INTRO_BOX_FIELD:
        return InsideSurveyInsideInfo.ELECTRICITY_OTHER_INFO_SUBTITLE;
    }
  }

  getValidationError(checkValidity?: boolean) {
    if (checkValidity)
      this.formValidationService.resetErrorsForPath(
        INSIDE_SURVEY_INSIDE_TECHNICAL_INFO
      );
    const updatedSurvey = {
      ...this.technicalInfoForm.get("generalInfo")?.value,
      ...this.technicalInfoForm.get("existingTelco")?.value,
      ...this.technicalInfoForm.get("accessToTelco")?.value,
    };

    let requiredFields = _.omit(
      updatedSurvey,
      "generalTechnicalInfoPhotoRemark",
      "electricityInTelcoRoomPhotoRemark",
      "roomAvailableForNewEquipmentPhotoRemark",
      "otherTelcoRemarks",
      "accessToTelcoGeneralRemarks",
      "proximusEquipmentPhotoRemark",
      "telcoRoomPhotoRemark",
      "nrOfCopperIntros",
      "nrOfDesiredFibreIntros",
      "existingTelcoCoax",
      "existingTelcoConnections",
      "existingVerticalCabling",
      "existingTelcoCoaxQuantity",
      "individualCoaxCableFromBasement",
      "copperIntroType",
      "electricityInTelcoRoom"
    );
    const validationErrors: ValidationError[] = [];
    if (
      this.technicalInfoForm.get("generalInfo")?.value
        ?.verticalTechnicalShaft == false &&
      (this.technicalInfoForm.get("generalInfo")?.value?.quadrant ==
        Quadrant.A ||
        this.technicalInfoForm.get("generalInfo")?.value?.quadrant ==
          Quadrant.C)
    ) {
      if (checkValidity) {
        this.formValidationService.addError(
          INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
          InsideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
          InsideSurveyInsideInfo.QUADRANT_FIELD
        );
        this.formValidationService.addError(
          INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
          InsideSurveyInsideInfo.HORIZONTAL_VERTICAL_INFO_SUBTITLE,
          InsideSurveyInsideInfo.VERTICAL_SHAFT_FIELD
        );
      }
      validationErrors.push(
        new ValidationError(
          $localize`:@@validation.verticalshaft.required:Vertical Shaft`,
          "Combination of quadrant A or C with Vertical Shaft set to NO not allowed",
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.title:Inside technical info`
        )
      );
    }

    if (
      !this.insideSurveyService.areAdditionalGeneralQuestionsVisible(
        updatedSurvey
      )
    )
      requiredFields = _.omit(
        requiredFields,
        _.values(additionalQuestionFields)
      );

    const emptyField = _.findKey(
      requiredFields,
      (x) => x === null || x === undefined
    );
    Object.keys(requiredFields).forEach((field) => {
      const value = this.technicalInfoForm.get("generalInfo")?.value[field];
      if (value === null || value === undefined) {
        if (checkValidity)
          this.formValidationService.addError(
            INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
            this.getSubtitleByField(field),
            field
          );

        validationErrors.push(
          new ValidationError(
            $localize`:@@validation.fieldisrequired:Field is required`,
            `${propertyNames[field]} should not be empty`,
            $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.title:Inside technical info`
          )
        );
      }
    });

    if (
      this.technicalInfoForm.get("generalInfo")?.value
        ?.verticalTechnicalShaft &&
      _.get(this, "pictures.generalTechnicalInfoPhotos", []).length < 1
    ) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
          InsideSurveyInsideInfo.VERTICAL_PHOTO_SUBTITLE,
          InsideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_PHOTOS
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@validation.photo.required:Photo is required`,
          "Vertical image is required",
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.title:Inside technical info`
        )
      );
    }

    if (
      this.technicalInfoForm.get("generalInfo")?.value
        ?.electricityInTelcoRoom &&
      _.get(this, "pictures.electricityInTelcoRoomPhotos", []).length < 1
    ) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
          InsideSurveyInsideInfo.ELECTRICITY_PHOTO_SUBTITLE,
          InsideSurveyInsideInfo.ELECTRICITY_TELCO_ROOM_PHOTOS_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@validation.photo.required:Photo is required`,
          "Electricity In Telco Room image is required",
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.title:Inside technical info`
        )
      );
    }
    if (
      this.technicalInfoForm.get("generalInfo")?.value
        ?.roomAvailableForFutureIntroBox &&
      _.get(this, "pictures.roomAvailableForNewEquipmentPhotos", []).length < 1
    ) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
          InsideSurveyInsideInfo.ELECTRICITY_PHOTO_SUBTITLE,
          InsideSurveyInsideInfo.ROOM_AVAILABLE_NEW_EQUIPMENT_PHOTOS_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@validation.photo.required:Photo is required`,
          "Room Available for new equipment image is required",
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.title:Inside technical info`
        )
      );
    }
    var coaxQuantity =
      this.technicalInfoForm.get("existingTelco")?.value
        .existingTelcoCoaxQuantity;
    if (coaxQuantity && !this.inMinMax(coaxQuantity, 0, 99)) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
          InsideSurveyInsideInfo.CONNECTIONS_CABLING_INFO_SUBTITLE,
          InsideSurveyInsideInfo.COAX_QUANTITY_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@validation.survey.coaxquantity.invalid:Coax quantity invalid`,
          "Coax quantity should be between 0 and 99",
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.title:Inside technical info`
        )
      );
    }

    var tsaType = this.technicalInfoForm.get("noAdminTSA").value.tsaType;
    if (tsaType === null || tsaType === undefined) {
      this.formValidationService.addError(
        INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
        InsideSurveyInsideInfo.TSA_TECHNICALSOLUTION_NOT_PROVIDED,
        InsideSurveyInsideInfo.TSA_TECHNICALSOLUTION_NOT_PROVIDED
      );
      validationErrors.push(
        new ValidationError(
          $localize`:@@validation.survey.technicalsolution.invalid:No checkbox is provided for tech. solution`,
          "At least one checkbox should be checked for tech. solution",
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.title:Inside technical info`
        )
      );
    }

    if (
      updatedSurvey.nrOfCopperIntros &&
      _.get(this, "pictures.outsideCopperIntroPhotos", []).length <
        updatedSurvey.nrOfCopperIntros
    ) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
          InsideSurveyInsideInfo.COPPER_INTROS_SUBTITLE,
          InsideSurveyInsideInfo.OUTSIDE_COPPER_INTROS_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@validation.photo.required:Photo is required`,
          "Not all outside copper intro image are added",
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.title:Inside technical info`
        )
      );
    }
    if (
      updatedSurvey.nrOfCopperIntros &&
      _.get(this, "pictures.insideCopperIntroPhotos", []).length <
        updatedSurvey.nrOfCopperIntros
    ) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
          InsideSurveyInsideInfo.COPPER_INTROS_SUBTITLE,
          InsideSurveyInsideInfo.INSIDE_COPPER_INTROS_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@validation.photo.required:Photo is required`,
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.validation.copperphotosmissing:Not all inside copper intro photo's are added`,
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.title:Inside technical info`
        )
      );
    }
    if (
      updatedSurvey.nrOfDesiredFibreIntros &&
      _.get(this, "pictures.outsideFibreIntroPhotos", []).length <
        updatedSurvey.nrOfDesiredFibreIntros
    ) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
          InsideSurveyInsideInfo.DESIRED_FIBER_SUBTITLE,
          InsideSurveyInsideInfo.OUTSIDE_DESIRED_FIBER_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@validation.photo.required:Photo is required`,
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.validation.outsidefiberphotomissing:Not all outside fibre intro image are added`,
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.title:Inside technical info`
        )
      );
    }
    if (
      updatedSurvey.nrOfDesiredFibreIntros &&
      _.get(this, "pictures.insideFibreIntroPhotos", []).length <
        updatedSurvey.nrOfDesiredFibreIntros
    ) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
          InsideSurveyInsideInfo.DESIRED_FIBER_SUBTITLE,
          InsideSurveyInsideInfo.INSIDE_DESIRED_FIBER_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@validation.photo.required:Photo is required`,
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.validation.insidefiberphotomissing:Not all inside fibre intro image are added`,
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.title:Inside technical info`
        )
      );
    }

    if (_.get(this, "pictures.telcoRoomPhotos", []).length < 1) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
          InsideSurveyInsideInfo.TELCO_ROOM_SUBTITLE,
          InsideSurveyInsideInfo.TELCO_ROOM_PHOTO_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@validation.photo.required:Photo is required`,
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.validation.atleastonetelcoroomphoto:At least 1 Telco Room image is required`,
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.title:Inside technical info`
        )
      );
    }
    if (_.get(this, "pictures.proximusEquipmentPhotos", []).length < 1) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
          InsideSurveyInsideInfo.PROXIMUS_EQUIPMENT_SUBTITLE,
          InsideSurveyInsideInfo.PROXIMUS_EQUIPMENT_PHOTO_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@validation.photo.required:Photo is required`,
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.validation.atleastonepxequipmentphoto:At least 1 Proximus equipment image is required`,
          $localize`:@@survey.inside.technicalinfo.inside.general.technicalinfo.title:Inside technical info`
        )
      );
    }
    if (validationErrors.length > 0 && checkValidity)
      return validationErrors[0];
    return undefined;
  }

  save(checkValidity?: boolean): Observable<boolean> {
    const updatedSurvey = {
      ...this.technicalInfoForm.get("generalInfo").value,
      ...this.technicalInfoForm.get("existingTelco").value,
      ...this.technicalInfoForm.get("accessToTelco").value,
      ...this.technicalInfoForm.get("specialBuilding").value,
      ...this.technicalInfoForm.get("noAdminTSA").value,
    };

    if (checkValidity) {
      const error = this.getValidationError();
      if (error) {
        this.toastService.showWarnToast(error.title, error.message);
        return of(false);
      }
    }

    if (!this.detectChanges(updatedSurvey)) return of(true);

    if (this.isAuthCanWrite) {
      this.survey = { ...this.survey, ...updatedSurvey };
      const dto = {
        ...updatedSurvey,
        id: this.survey.id,
        proximusEquipmentPhotoRemarks:
          this.pictures.proximusEquipmentPhotos
            .filter((e) => e.remarkChanged)
            .map((photo) => {
              photo.remarkChanged = false;
              return new ProximusEquipmentPhotoRemarksDto(
                photo.data.id,
                photo[photoRemarks.proximusEquipmentPhotoRemark]
              );
            }) ?? [],
        generalTechnicalInfoPhotoRemark:
          this.pictures.generalTechnicalInfoPhotos
            .filter((e) => e.remarkChanged)
            .map((photo) => {
              photo.remarkChanged = false;
              return new ProximusEquipmentPhotoRemarksDto(
                photo.data.id,
                photo[photoRemarks.generalTechnicalInfoPhotoRemark]
              );
            }) ?? [],
        telcoRoomIntroPhotoRemarks:
          this.pictures.telcoRoomPhotos
            .filter((e) => e.remarkChanged)
            .map((photo) => {
              photo.remarkChanged = false;
              return new ProximusEquipmentPhotoRemarksDto(
                photo.data.id,
                photo[photoRemarks.telcoRoomIntroPhotoRemark]
              );
            }) ?? [],
        insideCopperIntroPhotoRemarks:
          this.pictures.insideCopperIntroPhotos
            .filter((e) => e.remarkChanged)
            .map((photo) => {
              photo.remarkChanged = false;
              return new ProximusEquipmentPhotoRemarksDto(
                photo.data.id,
                photo[photoRemarks.insideCopperIntroPhotoRemark]
              );
            }) ?? [],
        outsideCopperIntroPhotoRemarks:
          this.pictures.outsideCopperIntroPhotos
            .filter((e) => e.remarkChanged)
            .map((photo) => {
              photo.remarkChanged = false;
              return new ProximusEquipmentPhotoRemarksDto(
                photo.data.id,
                photo[photoRemarks.outsideCopperIntroPhotoRemark]
              );
            }) ?? [],
        insideFibreIntroPhotoRemarks:
          this.pictures.insideFibreIntroPhotos
            .filter((e) => e.remarkChanged)
            .map((photo) => {
              photo.remarkChanged = false;
              return new ProximusEquipmentPhotoRemarksDto(
                photo.data.id,
                photo[photoRemarks.insideFibreIntroPhotoRemark]
              );
            }) ?? [],
        outsideFibreIntroPhotoRemarks:
          this.pictures.outsideFibreIntroPhotos
            .filter((e) => e.remarkChanged)
            .map((photo) => {
              photo.remarkChanged = false;
              return new ProximusEquipmentPhotoRemarksDto(
                photo.data.id,
                photo[photoRemarks.outsideFibreIntroPhotoRemark]
              );
            }) ?? [],
      };

      if (this.pictures.roomAvailableForNewEquipmentPhotos[0]) {
        this.pictures.roomAvailableForNewEquipmentPhotos[0].remarkChanged =
          false;
        dto.roomAvailableForNewEquipmentPhotoRemark =
          this.pictures.roomAvailableForNewEquipmentPhotos[0][
            photoRemarks.roomAvailableForNewEquipmentPhotoRemark
          ];
      } else {
        dto.roomAvailableForNewEquipmentPhotoRemark = null;
      }
      if (this.pictures.electricityInTelcoRoomPhotos[0]) {
        this.pictures.electricityInTelcoRoomPhotos[0].remarkChanged = false;
        dto.electricityInTelcoRoomPhotoRemark =
          this.pictures.electricityInTelcoRoomPhotos[0][
            photoRemarks.electricityInTelcoRoomPhotoRemark
          ];
      } else {
        dto.electricityInTelcoRoomPhotoRemark = null;
      }
      return this._savingStateService.addInsideSurveyTechnicalInfo(
        UpdateInsideSurveyTechnicalInfoDTO.create(dto)
      );
    }
  }

  private detectChanges(updatedSurvey: Partial<InsideSurvey>) {
    var fields = [
      ...generalInfoTechnicalFields,
      ..._.values(additionalQuestionFields),
      ...existingTelcoFields,
      ...accessToTelcoFields,
      ...specialBuildingFields,
      ...noAdminTSAFields,
    ];
    return (
      !isEqual(pick(updatedSurvey, fields), pick(this.survey, fields)) ||
      this.pictures.proximusEquipmentPhotos.some((e) => e.remarkChanged) ||
      this.pictures.electricityInTelcoRoomPhotos.some((e) => e.remarkChanged) ||
      this.pictures.generalTechnicalInfoPhotos.some((e) => e.remarkChanged) ||
      this.pictures.insideCopperIntroPhotos.some((e) => e.remarkChanged) ||
      this.pictures.insideFibreIntroPhotos.some((e) => e.remarkChanged) ||
      this.pictures.outsideCopperIntroPhotos.some((e) => e.remarkChanged) ||
      this.pictures.outsideFibreIntroPhotos.some((e) => e.remarkChanged) ||
      this.pictures.roomAvailableForNewEquipmentPhotos.some(
        (e) => e.remarkChanged
      ) ||
      this.pictures.telcoRoomPhotos.some((e) => e.remarkChanged)
    );
  }
}
